import { number, object, string } from "yup";

export const createTemplateSchema = object({
  name: string().required("Title is required"),
  pageId: number().required("Page's id is required"),
});
